import { InputLabel, SelectLabel } from '../../../../../common/components/form/fields';
import { FORM_RULES } from "../../../../../helpers/validations";

const inputStyle = { fontSize: "1.6rem", padding: 20, borderRadius: ".5rem" };
const style = { textAlign: "left", fontSize: "1.6rem", paddingBottom: 0 };

export default (optionsRules) => [
	{
		component: InputLabel,
		type: "text",
		name: "name",
        label: "Nome",
        placeholder: "Nome do usuário",
		cols: "12 12 6 6",
		validate: [FORM_RULES.required],
		style,
		inputStyle
	},
	{
		component: InputLabel,
		type: "text",
		name: "email",
        label: "Email",
        placeholder:"usuario@uniastro.com",
		cols: "12 12 6 6",
		validate: [FORM_RULES.required, FORM_RULES.email, FORM_RULES.verifyEmail],
		style,
		inputStyle
	},
	{
		component: SelectLabel,
		type: "text",
		name: "active",
		label: "Ativado",
		options: [{label:'Sim', value: true}, {label:'Não', value:false}],
        placeholder: "Sim",
		cols: "12 12 6 6",
		validate: [FORM_RULES.required],
		style,
		selectStyle: inputStyle
	},
	{
		component: SelectLabel,
		type: "text",
		name: "rules",
		label: "Papel",
		options: optionsRules(),
        placeholder: "Selecione o papel do usuário",
		cols: "12 12 6 6",
		validate: [FORM_RULES.required],
		style,
		selectStyle: inputStyle
	}
];
